import GiveawayForm from '../components/GiveawayAutoForm';
import Loading from '../../../components/Loading';
import useEditGiveawayAuto from './useEditGiveawayAuto';

export default function EditGiveawayAuto() {
    const {
        isLoading,
        giveawayAuto,
        handleSubmit,
    } = useEditGiveawayAuto();

    return (
        <Loading loading={isLoading} >
            <GiveawayForm
                action='Editar'
                giveawayAuto={giveawayAuto}
                key={giveawayAuto?.id}
                onSubmit={handleSubmit}
            />
        </Loading>
    )
}
